import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "../../../../../common/services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class VerksamhetsomradeService {
    private readonly apiClient = inject(ApiClientService);

    uppdateraGeografisktMasterdataJuni2023(): Observable<any> {
        return this.apiClient.post("verksamhetsomrade/migration/UpdateGeografisktMasterdataJuni2023", null);
    }

    uploadVerksamhetsomrade(file: any, dryRun: boolean): Observable<any> {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("dryRun", dryRun.toString());

        return this.apiClient.post(`verksamhetsomrade/saveVerksamhetsomraden?dryRun=${dryRun}`, formData, true);
    }
}
